module.exports = __webpack_public_path__ + "img/open_in_new_gray_24px@2x.80db0c13.png";